<div class="pivot-dsp-graph" [ngStyle]="cssStyle">
    <pivot-icon-button  *ngFor="let item of itemCharts; let r = index " 
        (click)="onSelectedChange(item)"
        (mouseenter)="onHoverChart(item)" 
        (mouseleave)="onLeaveChart(item)"
        [styleClass]="item.selected ? 'btn-graph selected-chart' : 'btn-graph'"
        [icon]="'assets/images/' + item.image">
    </pivot-icon-button>
</div>
